<template lang="pug">
  div(:style="{backgroundImage: `url(${urlBodyBg})`}")
    div(class="container bg-white" style="min-height: calc(100vh - 190px);")
      router-view
</template>

<script>
import urlBodyBg from '@/assets/bg.png'

export default {
  name: 'About',
  data () {
    return {
      urlBodyBg
    }
  }
}
</script>
